export default function (ctrl) {

	ctrl.captchaKey = '6Lcf6w0UAAAAAJhWmbL6sbKixuSSrkJbkgs78Puc';

	return {
		setWidgetId: function (widgetId) {
			ctrl.widgetId = widgetId;
		},
		setResponse: function (response) {
			ctrl.captchaResponse = response;
		},
		cbExpiration: function () {
			ctrl.vcRecaptchaService.reload(ctrl.widgetId);
			ctrl.captchaResponse = null;
		}
	};
};
